import { render, staticRenderFns } from "./TextoOutrosFiltrosSelecionadosAutocomplete.vue?vue&type=template&id=02a96b3d&scoped=true"
import script from "./TextoOutrosFiltrosSelecionadosAutocomplete.vue?vue&type=script&lang=js"
export * from "./TextoOutrosFiltrosSelecionadosAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a96b3d",
  null
  
)

export default component.exports